module.exports = __webpack_public_path__ + "static/media/permission.df3e7d01.png";